import { render, staticRenderFns } from "./TemplateChartFees.vue?vue&type=template&id=f21dc0da&scoped=true&"
import script from "./TemplateChartFees.vue?vue&type=script&lang=js&"
export * from "./TemplateChartFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21dc0da",
  null
  
)

export default component.exports